import { useRef } from "react";
/** MUI */
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { makeStyles } from "@mui/styles";
/** - icons */
import CheckIcon from "@mui/icons-material/Check";

/** Helpers */
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    selectRoot: {
        padding: theme.spacing(1, 2),
        fontFamily: "inherit",
        fontSize: "inherit",
        borderRadius: 4,
        borderColor: "rgba(0, 0, 0, 0.23)",
        color: "inherit",
        flexGrow: 1,
        cursor: "pointer",
        /** Arrow */
        backgroundImage:
            "url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23131313%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 0.7rem top 50%",
        backgroundSize: "0.65rem auto",
        appearance: "none",
    },
    optionRoot: {
        opacity: 1,
        padding: theme.spacing(1, 2),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
}));

const SelectColumn = (props) => {
    const { id, column, choise, onChangeColumn, small, onSelectOpen, selectOpen, index } = props;

    const focusTrap = useRef();
    const classes = useStyles();
    const { t } = useTranslation();

    /** Handlers */
    const handleOpen = (open, title) => {
        focusTrap.current = title;
        onSelectOpen && onSelectOpen(title ? title : open ? column.title : false);
    };

    const handleChange = (event) => {
        const _newColumn = event.target.value;
        onChangeColumn({ column: _newColumn, id });
        handleOpen(false, _newColumn.title);
    };

    return (
        <FormControl fullWidth sx={{ mr: 2 }}>
            <InputLabel id={`label-${column?.id}`} sx={{ opacity: 0 }} htmlFor={`input-${column?.id}`}>
                {t(`Lista poziomu {{index}}{{dot}} - {{name}}{{dot}}`, {
                    index: index + 1,
                    dot: ".",
                    name: column.title,
                })}
            </InputLabel>
            <Select
                ref={(ref) => {
                    if (ref) {
                        if (selectOpen === column.title) {
                            ref.querySelector("[tabindex='0']")?.focus();
                        }
                    }
                }}
                labelId={`label-${column?.id}`}
                id="outlined-select-COLUMN"
                value={column}
                onChange={handleChange}
                className={classes.selectRoot0}
                size={"small"}
                fullWidth
                // sx={{ mr: 2 }}
                onFocus={(e) => {
                    onSelectOpen && onSelectOpen(focusTrap.current || column.title);
                }}
                onBlur={(e) => {
                    handleOpen(false);
                }}
                inputProps={{
                    // "aria-label": column?.title ,
                    "aria-labelledby": `label-${column?.id}`,
                    id: `input-${column?.id}`,
                }}
                SelectDisplayProps={{
                    // "aria-label": column?.title ,
                    "aria-labelledby": `label-${column?.id}`,
                    onMouseDownCapture: (e) => {
                        handleOpen(false);
                    },
                    onKeyDownCapture: (e) => {
                        if (e?.key === "Tab" || e?.key === "Enter") {
                            handleOpen(false);
                        }
                    },
                }}
                MenuProps={{
                    MenuListProps: {
                        id: `menu-${column?.id}`,
                    },
                }}
                renderValue={(value) => value?.title || ""}
            >
                {[...choise, column].map((option, i) => (
                    <MenuItem
                        key={i}
                        value={option}
                        disabled={column.idx + 1 === option.idx ? false : option.disabled}
                        className={classes.optionRoot}
                    >
                        {option?.title}
                        {column?.title_orig === option?.title_orig ? <CheckIcon /> : null}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SelectColumn;
